export function safeLocalStorage() {
  try {
    const testKey = "__safe_test__";
    window.localStorage.setItem(testKey, "1");
    window.localStorage.removeItem(testKey);
    return window.localStorage;
  } catch (e: any) {
    console.warn("localStorage is not available:", e.message);
    return null;
  }
}

// Export instance so you can reuse everywhere
export const storage = safeLocalStorage();
